import axios from '../axios'

const defaultData = {
  name: '',
  password: ''
}

const defaultDialog = {
  email: '',
  visible: false
}

function toHex (s) {
  let string = unescape(encodeURIComponent(s))
  let hex = ''
  for (let i = 0; i < string.length; i++) {
    hex += string.charCodeAt(i).toString(16)
  }
  return hex
}

const login = {
  namespaced: true,
  state: {
    data: defaultData,
    error: null,
    loading: false,
    dialog: defaultDialog,
    rules: {
      full_name: 'required',
      password: 'required',
      ic_no: 'required|min:14',
      confirm_password: 'required|confirmed:password',
      email_address: 'required|email',
      phone: 'required',
      cash: 'required'
    }
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    },
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setDialogEmail: function (state, payload = { email: '' }) {
      state.dialog.email = payload.email
    },
    setVisibleDialog: function (state, payload = { visible: false }) {
      state.dialog.visible = payload.visible
    }
  },
  actions: {
    patchData: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data, payload)
      context.commit('setData', { data })
    },
    resetData: async function (context, payload = {}) {
      context.commit('setData', { data: defaultData })
    },
    resetPassword: async function (context, payload = {}) {
      const email = context.state.dialog.email
      const apiUrl = '/userdb-' + toHex(email)
      context.commit('setLoading', { loading: true })
      try {
        let response = await axios.post(`/query`, { url: btoa(apiUrl) })
        if (response.data) {
          const data = {
            type: 'reset_password',
            email: email,
            eService: true
          }
          response = await axios.post(`/resetPassword`, data)
        }
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        return error
      } finally {
        context.commit('setDialogEmail', { email: '' })
        context.commit('setVisibleDialog', { visible: false })
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default login
